import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import  specialistRecordsCompositeView  from '../../../../templates/CCM/PatientList/specialistRecordsCompositeView';
import SpecialistRecordsItemView from './SpecialistRecordsItemView';

// Internal Dependencies - models/collections
import { FaxRecordModel } from './models/FaxRecordModel';

export default Marionette.CompositeView.extend({

	childViewContainer: '.specialist-records-container',

	className: 'row',

	childView: SpecialistRecordsItemView,

	initialize: function( options ) {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
		this.collection = new Backbone.Collection();
		this.controller = this.app.ccm_controller;
		this.controller.getPatientRecords( this.model.get( 'id' ) );
		this.collection.loading = true;
		this.listenTo( this.channel, 'set:patientRecords', this.setCollection );
		this.listenTo( this.collection, 'update', this.render );
	},

	getTemplate: function() {
		return specialistRecordsCompositeView( this.collection );
	},

	setCollection: function() {
		this.collection.loading = false;
		let records = this.controller.patientRecords.map( ( record ) => new FaxRecordModel( record ) );
		this.collection.renderNoResults = !(records && records.length);
		this.collection.add(records);
		!records.length && this.render();
	},

});
